import { useState } from "react";
import ButtonLoader from "./ButtonLoader";

const LicenseTypeForm = ({ licenseType, isLoading, onSubmit }) => {
  const [hrwlCode, setHrwlCode] = useState(licenseType?.hrwlCode || '');
  const [name, setName] = useState(licenseType?.name || '');
  const [description, setDescription] = useState(licenseType?.description || '');

  const handleSubmit = (e) => {
    e.preventDefault();

    const payload = {
      hrwlCode,
      name,
      description
    }

    onSubmit(payload);
  }

  return (
    <form
      onSubmit={handleSubmit}
      className="flex flex-col w-full"
    >
      <div className="p-4 flex flex-col gap-4">
        <label className="flex flex-col gap-1 w-full">
          <span>HRWL Code</span>

          <input
            type="text"
            value={hrwlCode}
            onChange={(e) => setHrwlCode(e.target.value)}
            required
          />
        </label>

        <label className='flex flex-col gap-1'>
          <span>Name</span>

          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
        </label>

        <label className='flex flex-col gap-1'>
          <span>Description</span>

          <textarea
            className='border rounded-md p-2 min-h-[100px]'
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            required
          />
        </label>

        <button className="ase-button-primary h-[48px] flex items-center justify-center">
          {isLoading ? <ButtonLoader /> : 'Submit'}
        </button>
      </div>
    </form>
  )
}

export default LicenseTypeForm;
